import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IGrupo } from '../../model';

@Injectable()
export class GrupoService extends EntityService<IGrupo> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'grupo'
    });
  }

  update(entity: IGrupo) {
    if (entity.parent) entity.parent_id = entity.parent.id;

    entity.parent = undefined;

    return super.update(entity);
  }
}
